// 家长状态管理模块
const state = {
  children: [],
  courses: [],
  messages: []
};

const mutations = {
  SET_CHILDREN(state, children) {
    state.children = children;
  },
  ADD_CHILD(state, child) {
    state.children.push(child);
  },
  SET_COURSES(state, courses) {
    state.courses = courses;
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages;
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message);
  }
};

const actions = {
  fetchChildren({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const children = [
          { id: 1, name: '张小明', age: 9, grade: '三年级', className: '一班', avatar: 'https://randomuser.me/api/portraits/children/4.jpg' },
          { id: 2, name: '张小红', age: 7, grade: '一年级', className: '二班', avatar: 'https://randomuser.me/api/portraits/children/5.jpg' }
        ];
        commit('SET_CHILDREN', children);
        resolve(children);
      }, 500);
    });
  },
  addChild({ commit }, childData) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const child = {
          id: Date.now(),
          ...childData,
          createTime: new Date().toISOString()
        };
        commit('ADD_CHILD', child);
        resolve(child);
      }, 500);
    });
  },
  fetchCourses({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const courses = [
          { id: 1, name: '数学提高班', teacher: '李老师', maxStudents: 20, currentStudents: 15, time: '周一、周三 16:00-17:30', location: '教室A101', fee: 2000 },
          { id: 2, name: '英语口语班', teacher: '王老师', maxStudents: 15, currentStudents: 12, time: '周二、周四 16:00-17:30', location: '教室B201', fee: 2500 },
          { id: 3, name: '科学实验班', teacher: '张老师', maxStudents: 25, currentStudents: 18, time: '周五 15:00-17:00', location: '实验室C302', fee: 1800 }
        ];
        commit('SET_COURSES', courses);
        resolve(courses);
      }, 500);
    });
  },
  fetchMessages({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const messages = [
          { id: 1, from: '李老师', to: '张家长', content: '您的孩子张小明今天表现很好，积极回答问题，请继续鼓励。', time: '2025-03-20 14:30' },
          { id: 2, from: '王老师', to: '张家长', content: '张小红今天英语测验成绩优异，得了95分。', time: '2025-03-19 16:45' }
        ];
        commit('SET_MESSAGES', messages);
        resolve(messages);
      }, 500);
    });
  }
};

const getters = {
  children: state => state.children,
  courses: state => state.courses,
  messages: state => state.messages
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 